import { GalleryItem } from "../interfaces";
export const sampleGalleryItems: GalleryItem[] = [
  {
    id: "img0",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/1006FDDC-010F-4213-8A21-DBBCB1E9D232.webp",
    alt: "1006FDDC-010F-4213-8A21-DBBCB1E9D232.webp",
  },
  {
    id: "img1",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/2360464A-022E-4675-A572-03D22EFD9451.webp",
    alt: "2360464A-022E-4675-A572-03D22EFD9451.webp",
  },
  {
    id: "img2",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/32502D2B-59ED-45D3-B414-38D36D38D07E.webp",
    alt: "32502D2B-59ED-45D3-B414-38D36D38D07E.webp",
  },
  {
    id: "img3",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/32AB9903-AC23-410F-9ED3-EE8DE2615022.webp",
    alt: "32AB9903-AC23-410F-9ED3-EE8DE2615022.webp",
  },
  {
    id: "img4",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/3CE7B50F-06B2-4CE8-BF5C-9D514736D3F7.webp",
    alt: "3CE7B50F-06B2-4CE8-BF5C-9D514736D3F7.webp",
  },
  {
    id: "img5",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/4637D528-82F0-4F11-BD46-B2A3BF589566.webp",
    alt: "4637D528-82F0-4F11-BD46-B2A3BF589566.webp",
  },
  {
    id: "img6",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/4E8F1832-F10F-4AC7-B831-BD250D26C91F.webp",
    alt: "4E8F1832-F10F-4AC7-B831-BD250D26C91F.webp",
  },
  {
    id: "img7",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/54FCEEB5-472A-43B6-94FA-C9E19FA6A23B.webp",
    alt: "54FCEEB5-472A-43B6-94FA-C9E19FA6A23B.webp",
  },
  {
    id: "img8",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/6B05B593-278E-4127-A7F8-FE2B8BDDADE7.webp",
    alt: "6B05B593-278E-4127-A7F8-FE2B8BDDADE7.webp",
  },
  {
    id: "img9",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/7B1E094C-9D6D-451F-84D2-16212009ED2A.webp",
    alt: "7B1E094C-9D6D-451F-84D2-16212009ED2A.webp",
  },
  {
    id: "img10",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/7D514650-5558-4581-A5F9-58A942AE48DA.webp",
    alt: "7D514650-5558-4581-A5F9-58A942AE48DA.webp",
  },
  {
    id: "img11",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/7FDD5D5A-090A-45CD-90E9-4DA93AA95393.webp",
    alt: "7FDD5D5A-090A-45CD-90E9-4DA93AA95393.webp",
  },
  {
    id: "img12",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/8025ACFA-6E90-48EB-9A38-5A0638405D73.webp",
    alt: "8025ACFA-6E90-48EB-9A38-5A0638405D73.webp",
  },
  {
    id: "img13",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/9B99DDD3-FEC9-40E4-B536-23A5565F9CA4.webp",
    alt: "9B99DDD3-FEC9-40E4-B536-23A5565F9CA4.webp",
  },
  {
    id: "img14",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/A1E06508-BA4E-4061-BA8B-C6F89D3BCB63.webp",
    alt: "A1E06508-BA4E-4061-BA8B-C6F89D3BCB63.webp",
  },
  {
    id: "img15",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/A55E1D45-268F-408B-9B25-77373C4E647B.webp",
    alt: "A55E1D45-268F-408B-9B25-77373C4E647B.webp",
  },
  {
    id: "img16",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/AD54111A-D30B-4A86-BFFB-5A42672C52F8.webp",
    alt: "AD54111A-D30B-4A86-BFFB-5A42672C52F8.webp",
  },
  {
    id: "img17",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/AE17FD15-28DA-4A26-B721-08C6204CBDD2.webp",
    alt: "AE17FD15-28DA-4A26-B721-08C6204CBDD2.webp",
  },
  {
    id: "img18",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/B32A1930-23E7-47ED-9185-530E2AC094FD.webp",
    alt: "B32A1930-23E7-47ED-9185-530E2AC094FD.webp",
  },
  {
    id: "img19",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/B579DE0B-A47A-4F5E-8CFC-18188C74C0E8.webp",
    alt: "B579DE0B-A47A-4F5E-8CFC-18188C74C0E8.webp",
  },
  {
    id: "img20",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/BABCCE56-BEF3-401E-990F-BD1F87F444C1.webp",
    alt: "BABCCE56-BEF3-401E-990F-BD1F87F444C1.webp",
  },
  {
    id: "img21",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/C23E7B2D-B780-4671-8E2A-020EC5C42BED.webp",
    alt: "C23E7B2D-B780-4671-8E2A-020EC5C42BED.webp",
  },
  {
    id: "img22",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/D35CA2F3-E90C-4FC9-A3D5-93E257636494.webp",
    alt: "D35CA2F3-E90C-4FC9-A3D5-93E257636494.webp",
  },
  {
    id: "img23",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/D87B068A-0C45-468F-9318-E6700E635FCC.webp",
    alt: "D87B068A-0C45-468F-9318-E6700E635FCC.webp",
  },
  {
    id: "img24",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/DF538C1A-72AA-4C20-BE70-F0839675F37B.webp",
    alt: "DF538C1A-72AA-4C20-BE70-F0839675F37B.webp",
  },
  {
    id: "img25",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/EE9AC3E6-504C-46F1-BEFF-D32A0FC6192D.webp",
    alt: "EE9AC3E6-504C-46F1-BEFF-D32A0FC6192D.webp",
  },
  {
    id: "img26",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/FB3262EA-764A-4665-BD2D-9CBA8DA5BD52.webp",
    alt: "FB3262EA-764A-4665-BD2D-9CBA8DA5BD52.webp",
  },
  {
    id: "img27",
    src: "https://raw.githubusercontent.com/SacredDelights/SacredDelights.github.io/refs/heads/main/src/gallery/F33B0F47-CFAB-40E7-8436-F0F449EB3C36.webp",
    alt: "F33B0F47-CFAB-40E7-8436-F0F449EB3C36.webp",
  },
];
